import { Link } from 'react-router-dom';

export default function Footer() {
  const footerLinks = {
    快速导航: [
      { to: '/', label: '首页' },
      { to: '/category/all', label: '全部分类' },
      { to: '/category/movie', label: '电影' },
      { to: '/category/tv', label: '电视剧' },
      { to: '/category/anime', label: '动漫' },
    ],
    热门分类: [
      { to: '/category/variety', label: '综艺' },
      { to: '/category/documentary', label: '纪录片' },
      { to: '/category/music', label: '音乐' },
      { to: '/category/game', label: '游戏' },
      { to: '/category/sports', label: '体育' },
    ],
    关于我们: [
      { to: '/about', label: '品牌介绍' },
      { to: '/about#reputation', label: '用户口碑' },
      { to: '/about#contact', label: '联系我们' },
    ],
  };

  return (
    <footer className="bg-foreground-950 text-background-200">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center">
                <i className="ri-play-circle-fill text-2xl text-primary-400"></i>
              </div>
              <span className="font-heading text-xl text-background-50">
                草莓视频
              </span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed">
              草莓视频在线播放平台，提供海量高清视频资源，无需下载即可流畅观看。随时随地享受优质在线播放体验。
            </p>
          </div>

          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <h3 className="text-sm font-semibold text-background-100 mb-4">
                {title}
              </h3>
              <ul className="space-y-2.5">
                {links.map((link) => (
                  <li key={link.to}>
                    <Link
                      to={link.to}
                      className="text-sm text-background-400 hover:text-background-100 transition-colors"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-6 border-t border-background-800/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; {new Date().getFullYear()} 草莓视频在线播放 版权所有 | 草莓视频高清在线播放 | 草莓视频免费在线观看
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors">
              隐私政策
            </a>
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors">
              服务条款
            </a>
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors">
              Cookie设置
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}